(() => {
const $98d6645d0877d579$var$viewBox = document.querySelector("#viewImage");
const $98d6645d0877d579$var$viewImages = $98d6645d0877d579$var$viewBox?.querySelectorAll("img");
function $98d6645d0877d579$var$clearViewItemActive() {
    var items = document.querySelector(".view-list").children;
    for(var i = 0; i < items.length; i++)items[i].classList.remove("active");
}
function $98d6645d0877d579$var$changeViewItem(item, itemName) {
    $98d6645d0877d579$var$clearViewItemActive();
    item.classList.toggle("active");
    $98d6645d0877d579$var$viewImages.forEach((item)=>item.classList.add("hide"));
    $98d6645d0877d579$var$viewBox.querySelector(`[data-view=${itemName}]`).classList.remove("hide");
}
// expose the fn in global scope for inline use
window.changeViewItem = $98d6645d0877d579$var$changeViewItem;

})();
//# sourceMappingURL=features.js.map
